module.exports = "https://cdn-assessment.mathletics.com/app/12/assets/images/bc87eef69cb57081ee4e07fc0ba17ba0.svg";